



























import { Component, Vue } from 'vue-property-decorator'
import DeckCover from '@/components/deck-cover.vue'
import NewDeckForm from '@/components/new-deck-form.vue'

@Component({
  components: { NewDeckForm, DeckCover }
})
export default class Home extends Vue {
  private popup = false
  private savedDecks: Deck[];

  constructor () {
    super()
    this.savedDecks = this.$storage.decks
  }

  private editDeck (deck: Deck) {
    console.log('would edit deck', deck.name, 'now')
  }

  private newDeck () {
    this.popup = true
  }
}
